import { Button, Form, Grid, Input, Link, Message } from '@arco-design/web-react';
import { IconUser } from '@arco-design/web-react/icon';
import Cookie from 'js-cookie';
import { ForwardedRef, forwardRef, useState } from 'react';
import logo from 'src/assets/logo.png';
import { domain } from 'src/util';
import http from 'src/util/http';

interface Props {}

const test = {
    phone: /^1[3456789]\d{9}$/,
};

const SMSInput = (props: {
    phone: () => string;
    value?: string;
    onChange?: (v: string) => void;
    onErr: (msg: string) => void;
    type?: 1 | 2 | 3;
}) => {
    const [text, setText] = useState<string>('获取验证码');

    const [disabled, setDisabled] = useState<boolean>(false);
    const sendSms = () => {
        if (!test.phone.test(props.phone())) {
            props.onErr('请输入正确的手机号');
            return;
        }
        let s = 60;
        setDisabled(true);
        const countdown = () => {
            if (s <= 0) {
                setDisabled(false);
                setText('获取验证码');
            } else {
                setText(`${s--}s`);
                window.setTimeout(countdown, 1000);
            }
        };
        countdown();
        http.post('send_sms', { phone: props.phone(), type: props.type });
    };
    const Btn = () => (
        <Button disabled={disabled} onClick={sendSms} style={{ background: 'transparent' }}>
            {text}
        </Button>
    );

    return <Input value={props.value} onChange={props.onChange} addAfter={<Btn />} />;
};

const Login = (props: Props, ref: ForwardedRef<any>) => {
    const [isRegister, setIsRegister] = useState(false);
    const [isReset, setIsReset] = useState(false);
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const setErr = (...args: any[]) => {
        let data: { [key: string]: { error: { message: string } } } = {};
        if (args.length === 2) {
            const [field, msg] = args;
            if (typeof field === 'string') {
                data[field] = {
                    error: {
                        message: msg as string,
                    },
                };
            }
            if (Array.isArray(field)) {
                field.forEach(item => {
                    data[item] = {
                        error: {
                            message: msg as string,
                        },
                    };
                });
            }
        }
        form.setFields(data);
    };
    const FormItem = Form.Item;
    const onSubmit = async (values: { [key: string]: string }) => {
        const loginHandle = () => {
            setLoading(true);
            http.post<{ token: string }>('user_auth', {
                account: values.account,
                passwd: values.passwd,
            })
                .then(res => {
                    const token = res.data.token;
                    Cookie.set('auth_token', token, { domain: domain() });
                    Message.success({ content: '登录成功' });
                    window.location.reload();
                })
                .catch(e => {
                    setErr(['account', 'passwd'], e);
                })
                .finally(() => setLoading(false));
        };
        if (isRegister) {
            if (!test.phone.test(values.account)) {
                return setErr('account', '请输入正确的手机号');
            }
            if (values.passwd !== values.rpasswd) {
                return setErr(['passwd', 'rpasswd'], '两次输入不一致');
            }
            setLoading(true);
            if (isReset) {
                http.post('user_reset', {
                    account: values.account,
                    passwd: values.passwd,
                    code: values.code,
                })
                    .then(res => {
                        loginHandle();
                    })
                    .catch((e: string) => {
                        if (e?.includes('验证码')) {
                            setErr('code', e);
                        }
                        if (e?.includes('手机号')) {
                            setErr('account', e);
                        }
                    })
                    .finally(() => setLoading(false));
            } else {
                http.post('user_create', {
                    account: values.account,
                    password: values.passwd,
                    code: values.code,
                })
                    .then(res => {
                        loginHandle();
                    })
                    .catch((e: string) => {
                        if (e?.includes('验证码')) {
                            setErr('code', e);
                        }
                        if (e?.includes('手机号')) {
                            setErr('account', e);
                        }
                    })
                    .finally(() => setLoading(false));
            }
        } else {
            loginHandle();
        }
    };
    const changeType = () => {
        form.clearFields();
        setIsRegister(!isRegister);
        setIsReset(false);
    };
    const reset = () => {
        setIsRegister(true);
        setIsReset(true);
    };

    return (
        <>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '8vw',
                    marginTop: '-20px',
                }}
            >
                <img src={logo} alt="云剪辑" style={{ objectFit: 'cover', maxHeight: '100%' }} />
            </div>
            <Form form={form} onSubmit={onSubmit} layout="vertical" autoComplete="off" size="large">
                <FormItem field="account" rules={[{ required: true, message: '账号不能为空' }]}>
                    <Input
                        placeholder={!isRegister ? '请输入账户或手机号' : '请输入手机号 '}
                        prefix={isRegister ? null : <IconUser />}
                        addBefore={isRegister ? '+86' : null}
                    />
                </FormItem>
                {isRegister && (
                    <FormItem field="code" rules={[{ required: true, message: '验证码不能为空' }]}>
                        <SMSInput
                            phone={() => form.getFieldValue('account')}
                            onErr={msg => setErr('account', msg)}
                            type={isReset ? 3 : 1}
                        />
                    </FormItem>
                )}
                <FormItem field="passwd" rules={[{ required: true, message: '请输入密码' }]}>
                    <Input.Password
                        placeholder={isReset ? '请输入新密码' : '请输入密码'}
                        autoComplete="off"
                    />
                </FormItem>
                {isRegister && (
                    <FormItem field="rpasswd" rules={[{ required: true, message: '请输入密码' }]}>
                        <Input.Password placeholder="请重复输入密码" autoComplete="off" />
                    </FormItem>
                )}
                <Grid.Row>
                    <Grid.Col>
                        <Button loading={loading} style={{ width: '100%' }} htmlType="submit">
                            {isRegister ? '注册' : '登录'}
                        </Button>
                    </Grid.Col>
                </Grid.Row>
                <Grid.Row style={{ marginTop: '10px' }}>
                    <Grid.Col span={12}>
                        <Link onClick={changeType}>{isRegister ? '登录' : '注册'}</Link>
                    </Grid.Col>
                    <Grid.Col span={12}>
                        {!isRegister && (
                            <Link onClick={reset} style={{ float: 'right' }}>
                                忘记密码
                            </Link>
                        )}
                    </Grid.Col>
                </Grid.Row>
            </Form>
        </>
    );
};
export default forwardRef(Login);
